import Comments from "./Components/Comments";
import data from "./data.json";
import './index.css';

function Comentarios() {

    const currentUser = data.currentUser;

    return (
        <div className="Comentarios">
            <Comments currentUser={currentUser} />
        </div>
    );
}


export default Comentarios;
